exports.defaultSettings = {
  navigationType: 'hover', // -- "hover" or "scroller" or "thumbsAndArrows",
  menuPosition: 'bottom',
  menuItemWidth: 'default', // -- number or "default"
  menuItemHeight: 'default',
  isSyncMainAreaAndNavigatinoAreas: true,
}
